import moment from 'moment';

export const formatdate_DMY = (isoDate, formatStr = "DD-MM-YYYY") => {
  if (!isoDate) return "";
  return moment.utc(isoDate).format(formatStr);

}


